
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitokkonkancab() {



    const cardData =
    {
        keyword: 'Mumbai to Konkan Darshan Cab Booking',
        heading: 'Skyline Cabs: Mumbai to Konkan Darshan Cab Booking',
        headingDescription: 'Skyline Cabs offers comfortable and reliable Mumbai to Konkan Darshan Cab Booking services for an unforgettable coastal journey. Whether you are planning to explore the serene beaches, ancient temples, or lush greenery of the Konkan region, our well-maintained vehicles and professional drivers ensure a smooth and enjoyable ride. Enjoy door-to-door pickups from anywhere in Mumbai, transparent pricing, flexible travel schedules, and 24/7 customer support. Book your Mumbai to Konkan Darshan cab with Skyline Cabs today and discover the breathtaking beauty of Maharashtra’s coastal paradise!',

        top: 'Top Places to Visit in Konkan with Skyline Cabs',

"topPlaces": [
    {
        "title": "Alibaug Beach",
        "description": "Located in the coastal town of Alibaug, this beach is known for its clean shores, water sports, and scenic views. The nearby Kolaba Fort adds historical charm to the beach experience."
    },
    {
        "title": "Murud Janjira Fort",
        "description": "Situated on an island off the coast of Murud, Janjira Fort is a majestic sea fort with a fascinating history. The fort is known for its strong fortifications and offers stunning views of the Arabian Sea."
    },
    {
        "title": "Kashid Beach",
        "description": "Kashid Beach is a tranquil haven for beach lovers, offering clear waters and golden sands. The beach is ideal for a peaceful getaway, water sports, and enjoying the beauty of nature."
    },
    {
        "title": "Ganpatipule",
        "description": "A serene coastal town in Ratnagiri, Ganpatipule is famous for its beautiful beach and the Ganapati Temple, which houses a revered idol of Lord Ganesha. It's a popular spot for religious pilgrims and beach lovers alike."
    },
    {
        "title": "Tarkarli Beach",
        "description": "Tarkarli is known for its pristine beaches and crystal-clear waters. It's a favorite destination for water sports, including scuba diving, and offers a peaceful atmosphere for relaxation."
    },
    {
        "title": "Dapoli",
        "description": "Known for its beaches and cool climate, Dapoli is a coastal town offering scenic beauty and historical landmarks like the Keshavraj Temple. It’s perfect for a relaxing retreat amidst nature."
    },
    {
        "title": "Ratnagiri",
        "description": "The birthplace of the famous freedom fighter, Lokmanya Tilak, Ratnagiri is a historical town with beautiful beaches, forts, and the serene Thibaw Palace. It's also known for its delicious mangoes."
    },
    {
        "title": "Sindhudurg Fort",
        "description": "Located on an island off Malvan, Sindhudurg Fort is a 17th-century fort built by Chhatrapati Shivaji Maharaj. The fort offers panoramic views of the Arabian Sea and is a great place for history enthusiasts."
    },
    {
        "title": "Hedvi Temple",
        "description": "Located in the Ratnagiri district, the Hedvi Temple is dedicated to Lord Ganesha and is famous for its stunning coastal setting. It’s an important pilgrimage site for devotees of Lord Ganesha."
    },
    {
        "title": "Kunkeshwar Temple",
        "description": "This ancient Shiva temple located near the beach in the Sindhudurg district offers a unique experience of worshipping in a serene and scenic coastal environment. It’s known for its peaceful ambiance."
    }
],

"services": [
    {
      "name": "Mumbai to Konkan Darshan Cab",
      "description": "Skyline Cabs offers comfortable and scenic taxi services for Konkan Darshan from Mumbai. Enjoy a beautiful ride as you explore the coastal beauty of Konkan."
    },
    {
      "name": "Konkan Darshan Taxi Service",
      "description": "Book a reliable Konkan Darshan taxi service with Skyline Cabs. We offer safe and comfortable rides to explore the picturesque locations of Konkan from Mumbai."
    },
    {
      "name": "Konkan Tour from Mumbai",
      "description": "Take a memorable Konkan tour with Skyline Cabs. Our taxis are perfect for exploring the coastal beauty of Konkan, with comfortable and well-maintained vehicles."
    },
    {
      "name": "Mumbai to Konkan One Day Cab",
      "description": "Book a one-day cab for Konkan from Mumbai with Skyline Cabs. Enjoy a short, stress-free trip exploring the stunning beauty of the Konkan region."
    },
    {
      "name": "Konkan Sightseeing Taxi Booking",
      "description": "Book a sightseeing taxi for your Konkan trip with Skyline Cabs. Our experienced drivers will ensure you visit all the must-see spots in the region."
    },
    {
      "name": "Taxi Service for Konkan Darshan",
      "description": "Choose Skyline Cabs for your Konkan Darshan journey. We provide comfortable and safe taxi services to help you experience the coastal charm and natural beauty of Konkan."
    }
  ],
  "tableData": [
    ["Mumbai to Konkan Darshan Cab", "Konkan Darshan Taxi Service"],
    ["Konkan Tour from Mumbai", "Mumbai to Konkan One Day Cab"],
    ["Konkan Sightseeing Taxi Booking", "Taxi Service for Konkan Darshan"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Reliable Mumbai to Konkan Darshan Cab Service",
      "WhyChoosedescription": "Embark on a scenic and hassle-free journey from Mumbai to Konkan with our reliable cab service. Perfect for those looking to explore the beauty of Konkan on a comfortable ride."
    },
    {
      "WhyChooseheading": "Comfortable and Scenic Journey Cabs",
      "WhyChoosedescription": "Our cabs are designed for long, picturesque drives, ensuring a comfortable and smooth ride while you enjoy the breathtaking views of the Konkan coastline."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Get the best value for your trip with affordable and transparent pricing. No hidden fees, just clear and honest rates for your Mumbai to Konkan Darshan experience."
    },
    {
      "WhyChooseheading": "Experienced and Friendly Drivers",
      "WhyChoosedescription": "Our experienced drivers are well-versed with the Konkan route, offering a safe, courteous, and enjoyable ride while ensuring you reach your destinations smoothly."
    },
    {
      "WhyChooseheading": "Well-Maintained, Sanitized, and Safe Vehicles",
      "WhyChoosedescription": "Travel in a vehicle that’s regularly cleaned and sanitized, maintaining the highest safety and hygiene standards, ensuring comfort and peace of mind during your trip."
    },
    {
      "WhyChooseheading": "Flexible Travel Options for Konkan Darshan",
      "WhyChoosedescription": "Whether you're planning a one-way trip or a multi-stop Konkan Darshan tour, we offer flexible options to suit your travel needs."
    },
    {
      "WhyChooseheading": "24/7 Booking Assistance and Support",
      "WhyChoosedescription": "Book your Mumbai to Konkan Darshan cab anytime with our easy online system or by calling our 24/7 customer support for seamless service."
    },
    {
      "WhyChooseheading": "Ideal for Family, Group, or Solo Travelers",
      "WhyChoosedescription": "Whether you're traveling solo, with family, or in a group, our cabs are perfect for enjoying the charm of Konkan at your own pace, comfortably and reliably."
    }
  ]
  
  









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Mumbai to Konkan Darshan with Skyline Cabs?',
            answer:
                'Booking a cab for Konkan Darshan from Mumbai is easy and convenient. You can book through our website, mobile app, or by calling our customer support. Simply enter your pickup location, travel date, and select your preferred vehicle for the journey.',
        },
        {
            id: 2,
            question: 'What is the distance and travel time for Mumbai to Konkan Darshan?',
            answer:
                'The distance for a Konkan Darshan trip from Mumbai varies depending on the specific locations you want to visit, but generally, it is around 200-350 km. The travel time usually ranges from 5 to 8 hours, depending on your destinations, traffic, and road conditions.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for the Mumbai to Konkan Darshan trip?',
            answer:
                'We offer a variety of vehicles for the Mumbai to Konkan Darshan journey, including Swift Dzire, Ertiga, Innova Crysta, Kia Carens, and SUVs. For larger groups or family trips, we provide Tempo Travellers and luxury coaches.',
        },
        {
            id: 4,
            question: 'Are your cab fares for Mumbai to Konkan Darshan fixed?',
            answer:
                'Yes, we provide fixed and transparent pricing for your Mumbai to Konkan Darshan journey. The fare includes vehicle rental, driver charges, fuel, tolls, taxes, and any applicable service fees. You will know the total fare before confirming your booking.',
        },
        {
            id: 5,
            question: 'Can I book a one-way cab from Mumbai to Konkan Darshan?',
            answer:
                'Yes, we offer one-way cab options for your convenience. You can choose a round-trip service if you plan to return to Mumbai later or opt for a custom itinerary based on your Konkan Darshan tour preferences.',
        },
        {
            id: 6,
            question: 'What is the best time to travel for Konkan Darshan from Mumbai?',
            answer:
                'The best time to visit Konkan is during the cooler months, from October to March. However, Skyline Cabs operates year-round, and our drivers are experienced in handling different weather conditions.',
        },
        {
            id: 7,
            question: 'Are stopovers allowed during the Mumbai to Konkan Darshan journey?',
            answer:
                'Yes, we allow short stopovers for sightseeing, meals, or taking a break during the Konkan Darshan journey. Let the driver know if you wish to visit any specific spots along the way.',
        },
        {
            id: 8,
            question: 'What payment options are available for the Mumbai to Konkan Darshan cab?',
            answer:
                'We accept various payment methods, including UPI, credit/debit cards, net banking, and cash payments after the trip. All online payments are secure and processed through trusted gateways.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my Mumbai to Konkan Darshan cab booking?',
            answer:
                'Yes, you can modify or cancel your booking easily via our website, mobile app, or by contacting customer support. We offer flexible cancellation policies to accommodate changes in your plans.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for the Mumbai to Konkan Darshan trip?',
            answer:
                'Skyline Cabs offers a comfortable, safe, and reliable journey for your Konkan Darshan trip. We provide well-maintained vehicles, experienced drivers, and transparent pricing. Our excellent customer service ensures that your trip is memorable and hassle-free.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Raghav Joshi",
            rating: 5,
            review: "The Konkan Darshan trip with Skyline Cabs was an amazing experience! The driver was knowledgeable about the region, and the vehicle was comfortable. The scenic drive along the coast was unforgettable. Highly recommend it for a family trip!"
        },
        {
            name: "Miss. Priya Desai",
            rating: 4,
            review: "We had a great time on our Konkan Darshan tour with Skyline Cabs. The journey was smooth, and the car was spacious. A little more time at some sightseeing spots would have been great, but overall, a fantastic experience!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Konkan Darshan Cab",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-konkan-darshan-cab.jpg",
  "description": "Book Mumbai to Konkan Darshan Cab with Skyline Cabs to explore scenic beaches, temples, and forts across Ratnagiri, Sindhudurg, Ganpatipule, and more. AC sedans, SUVs, and tempo travellers available with experienced drivers for group and family tours.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8127"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7400",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-konkan-darshan-cab"
  }
};


      
      
      

    return (
        <div>
<Helmet>
  <title>Mumbai to Konkan Darshan Cab | Ganpatipule & Coastal Tour | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Konkan Darshan Cab with Skyline Cabs to explore scenic beaches, temples, and forts across Ratnagiri, Sindhudurg, Ganpatipule, and more. AC sedans, SUVs, and tempo travellers available with experienced drivers for group and family tours." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Konkan Darshan Cab, Konkan Tour from Mumbai, Ganpatipule Cab Mumbai, Mumbai to Ratnagiri Taxi, Sindhudurg Darshan Cab, Coastal Maharashtra Tour Cab, SUV Cab to Konkan, AC Cab Booking Konkan, Skyline Cabs Konkan Darshan" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/86.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitokkonkancab;